import api from './api';
import { AppResponse } from "../models/common/app-response";
import { LinkObjectDto } from '../models/common/linkObjectDto';
import { PaginatedResponse } from '../models/common/paginated-response';
import {
    AwaitingWorkplaceSignatureDocumentDto,
    BulkSignMedicalCheckupDocumentsResultDto,
    BulkSignMedicalCheckupDocumentsWithPhysicalTokenDto,
    WorkplaceMedicalCheckupDocumentsDto,
    WorkplaceSignatureDocumentFilter,
} from '../models/medicalCheckupDocuments/workplaceSignatureDtos';

class MedicalCheckupDocumentsService {
    baseUrl: string = "/api/v1/medical-checkup-documents";

    getDocumentDownloadLink = (documentId: number) => {
        return api.get<AppResponse<LinkObjectDto>>(`${this.baseUrl}/${documentId}/download-link`);
    }

    /**
     * Реестр «Направления на подпись»: неподписанные справки осмотров текущего медика.
     */
    getAwaitingWorkplaceSignature = (filter: WorkplaceSignatureDocumentFilter) => {
        return api.post<AppResponse<PaginatedResponse<AwaitingWorkplaceSignatureDocumentDto>>>(`${this.baseUrl}/workplace-signature/filter`, filter);
    }

    /**
     * Сборка PDF справок для подписи физическим токеном.
     */
    prepareWorkplaceSignature = (documentIds: number[]) => {
        return api.post<AppResponse<WorkplaceMedicalCheckupDocumentsDto>>(`${this.baseUrl}/workplace-signature/prepare`, { documentIds })
            .then((response) => response.data.data);
    }

    /**
     * Приём подписей справок, подписанных физическим токеном.
     */
    signWorkplaceWithPhysicalToken = (data: BulkSignMedicalCheckupDocumentsWithPhysicalTokenDto) => {
        return api.post<AppResponse<BulkSignMedicalCheckupDocumentsResultDto>>(`${this.baseUrl}/workplace-signature/physical-token`, data)
            .then((response) => response.data.data);
    }
}

export const medicalCheckupDocumentsService = new MedicalCheckupDocumentsService();
